import { TenantPolicy } from '@activepieces/shared';

/**
 * Returns true only when the tenant policy has been loaded and explicitly
 * disables MCP. Returns false while loading (policy undefined) to avoid
 * flashing a blocked state on a Business customer.
 */
export const isMcpBlocked = (policy: TenantPolicy | undefined): boolean =>
  policy?.mcpEnabled === false;
